export enum ClaimsPath {
  number = "number"
}

export interface PathParams {
  [ClaimsPath.number]: string;
}
